
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const MonitorIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M19.75 13C14.9175 13 11 16.9175 11 21.75V61.25C11 66.0825 14.9175 70 19.75 70H44.5V76H33.5C31.567 76 30 77.567 30 79.5C30 81.433 31.567 83 33.5 83H62.5C64.433 83 66 81.433 66 79.5C66 77.567 64.433 76 62.5 76H51.5V70H76.25C81.0825 70 85 66.0825 85 61.25V21.75C85 16.9175 81.0825 13 76.25 13H19.75ZM76.25 63C77.2165 63 78 62.2165 78 61.25V58H18V61.25C18 62.2165 18.7835 63 19.75 63H76.25ZM78 51V21.75C78 20.7835 77.2165 20 76.25 20H19.75C18.7835 20 18 20.7835 18 21.75V51H78Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5 21.75C14.5 18.8505 16.8505 16.5 19.75 16.5H76.25C79.1495 16.5 81.5 18.8505 81.5 21.75V61.25C81.5 64.1495 79.1495 66.5 76.25 66.5H19.75C16.8505 66.5 14.5 64.1495 14.5 61.25V21.75Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M19.75 13C14.9175 13 11 16.9175 11 21.75V61.25C11 66.0825 14.9175 70 19.75 70H44.5V76H33.5C31.567 76 30 77.567 30 79.5C30 81.433 31.567 83 33.5 83H62.5C64.433 83 66 81.433 66 79.5C66 77.567 64.433 76 62.5 76H51.5V70H76.25C81.0825 70 85 66.0825 85 61.25V21.75C85 16.9175 81.0825 13 76.25 13H19.75ZM76.25 63C77.2165 63 78 62.2165 78 61.25V58H18V61.25C18 62.2165 18.7835 63 19.75 63H76.25ZM78 51V21.75C78 20.7835 77.2165 20 76.25 20H19.75C18.7835 20 18 20.7835 18 21.75V51H78Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5 21.75C14.5 18.8505 16.8505 16.5 19.75 16.5H76.25C79.1495 16.5 81.5 18.8505 81.5 21.75V61.25C81.5 64.1495 79.1495 66.5 76.25 66.5H19.75C16.8505 66.5 14.5 64.1495 14.5 61.25V21.75Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
